import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { displays } from 'investira.react.lib';
import { formats, validators } from 'investira.sdk';
import { Card, Stack, Typography, Chip, useMediaQuery } from 'investira.react.components';
import { PessoaImage, MutedCopy } from '../../../components/molecules';
import { SETORES } from '../../../enums';
import utils from '../../../utils';
const EmpresasItem = memo(props => {
  const {
    logo_pessoa_id,
    logo_ok,
    cnpj,
    pessoa_id,
    mercado,
    pessoa,
    pessoa_fantasia,
    setor,
    top_setor,
    top_setor_id,
    pl,
    cs,
    b3,
    pessoa_tipo_id
  } = props.data;
  const xPessoaTipoList = utils.helpers.getPessoaTipoById(pessoa_tipo_id);
  const xTopSetor = validators.isEmpty(top_setor) ? SETORES[top_setor_id]?.setor : top_setor;
  const xPrimaryChipLabel = props.showSetor ? setor : xTopSetor;
  const isUpMd = useMediaQuery(pTheme => pTheme.breakpoints.up('md'));

  return (
    <Card>
      <Link to={`${props.pathnameBase}/${pessoa_id}`}>
        <Stack
          direction="row"
          sx={{
            cursor: 'pointer',
            px: 2,
            py: 2
          }}
          spacing={2}>
          <Stack>
            <PessoaImage
              logoPessoaId={logo_pessoa_id}
              alt={pessoa}
              hasLogo={logo_ok}
              mercado={mercado}
              size={40}
            />
          </Stack>

          <Stack flexGrow={1} minWidth={0} spacing={1}>
            <Stack flexGrow={1} direction="row">
              <Stack flexGrow={1} minWidth={0}>
                <Stack flexGrow={1}>
                  <Typography
                    variant="body2"
                    color="textPrimary"
                    sx={{
                      fontWeight: 600
                    }}
                    component="h3">
                    {pessoa_fantasia || pessoa}
                  </Typography>
                </Stack>
                <Stack direction="column" mb={1}>
                  <Typography
                    variant="caption"
                    color="textPrimary"
                    sx={{
                      display: {
                        xs: 'none',
                        sm: 'inline-block'
                      }
                    }}>
                    {`${pessoa}`}
                  </Typography>
                  {cnpj && (
                    <Stack direction="row">
                      <MutedCopy value={cnpj}>
                        <Typography variant="caption" color="textSecondary">
                          {`${displays.cnpj(cnpj)}`}
                        </Typography>
                      </MutedCopy>
                    </Stack>
                  )}
                </Stack>
              </Stack>
              {isUpMd && (
                <Stack alignItems="flex-end" ml={1} minWidth={0} maxWidth="40%">
                  <Stack justifyContent="end" maxWidth="100%">
                    {xPrimaryChipLabel && (
                      <Chip
                        label={xPrimaryChipLabel}
                        size="small"
                        color="primary"
                        sx={{
                          maxWidth: '100%',
                          '& .MuiChip-label': {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }
                        }}
                      />
                    )}
                  </Stack>
                </Stack>
              )}
            </Stack>

            <Stack
              sx={{
                gap: '8px 8px'
              }}
              flexWrap="wrap"
              direction="row">
              {!isUpMd && xPrimaryChipLabel && (
                <Chip
                  label={xPrimaryChipLabel}
                  size="small"
                  color="primary"
                  sx={{
                    maxWidth: '100%',
                    '& .MuiChip-label': {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }
                  }}
                />
              )}
              {!props.showSetor && !validators.isEmpty(setor) && (
                <Chip
                  key={setor}
                  label={setor}
                  size="small"
                  color="secondary"
                  sx={{
                    maxWidth: '230px'
                  }}
                />
              )}
              {xPessoaTipoList.map(xPessoaTipo => {
                return (
                  <Chip
                    key={xPessoaTipo.id}
                    label={xPessoaTipo.descricao}
                    size="small"
                    color="secondary"
                  />
                );
              })}

              {b3?.codigo_emissor && (
                <Chip label={b3?.codigo_emissor} size="small" color="secondary" />
              )}

              {!validators.isNull(pl) && (
                <Chip
                  label={`Patrimônio líquido: ${formats.friendlyNumber(pl, 2, true)}`}
                  size="small"
                  color="secondary"
                />
              )}
              {!validators.isNull(cs) && (
                <Chip
                  label={`Capital social: ${formats.friendlyNumber(cs, 2, true)}`}
                  size="small"
                  color="secondary"
                />
              )}
            </Stack>
          </Stack>
        </Stack>
      </Link>
    </Card>
  );
});
export default EmpresasItem;
